import React, { ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { Squish } from '@grubhubprod/gh-cookbook-react/dist';
import { getWindow } from 'src/utilities/window';
import { FIXED_SIGNUP_FOOTER_ID } from 'src/components/common/features/Signup/constants';

export interface SignupStepFooterProps {
  children: ReactNode;
}

export function SignupStepFooter({
  children,
}: SignupStepFooterProps): JSX.Element | null {
  const window = getWindow();
  const mountNode = window.document.getElementById(FIXED_SIGNUP_FOOTER_ID);

  const bar = (
    <Squish inset="md" dimension="2" backgroundColor="backgroundBase">
      {children}
    </Squish>
  );

  if (!mountNode) {
    return null;
  }

  return createPortal(bar, mountNode);
}
